<template>
    <div id="cmswycshowbox" style="position: absolute; z-index: 10000; background-color: white; height: 150px; width: 320px; border: 1px solid rgb(27, 122, 222);">
        <p style="
		line-height: 30px;
		background-color: #0c7df5;
		color: white;
		font-size: 12px;
		padding-left: 10px;
		">
		<span>提示</span><span @click="showboxclose(3)" style="float: right;margin-top: 5px;margin-right: 5px;cursor: pointer;">
		<img src="https://aiplugin.5118.com/images/close.png">
		</span></p>
		<p style="vertical-align: middle;text-align: center;margin-top: 20px;
		line-height: 40px;font-size: 15px;">{{keywords}}已提取完成！</p>
		<p style="vertical-align: middle;text-align: center;font-size: 12px;color: black;
		">请到对应的文本输入框中查看提取的内容！</p>
		</div>
</template>
<script>
export default {
    data(){
        return {
            keywords:''
        }
    },
    mounted(){
        this.listenshowbox();
    },
    methods:{
        listenshowbox(){
            this.$showboxmessage.listen("_5118_Showbox_keywords_Info", (msg) => {
                this.keywords=msg;
            });
        },
        showboxclose(jumptype){
            if(jumptype===3){
                this.$showboxmessage.addTarget(window.parent, 'parent');
                this.$showboxmessage.targets['parent'].send("Send_ShowBox_Close",3);
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/ShowboxMsg.vue